import React from 'react';
import PropTypes from 'prop-types';
import ExpertiseList from './ExpertiseList';
import CustomTooltip from '../../Utils/CustomTooltip';

const JobResponsibilitiesFit = ({ responsibilitiesFit, showSources = true }) => {
  return (
    <div className="border border-gray-200 rounded-lg p-6 bg-white">
      <div className="flex justify-between items-start mb-4">
        <h4 className="text-xl font-semibold text-gray-800">Job Responsibilities Fit</h4>
        {showSources && responsibilitiesFit?.source && (
          <CustomTooltip content={responsibilitiesFit.source} position="left">
            <span className="text-xs text-blue-600 cursor-help hover:text-blue-800 flex items-center">
              <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
              Source
            </span>
          </CustomTooltip>
        )}
      </div>
      
      {responsibilitiesFit && responsibilitiesFit.value && Array.isArray(responsibilitiesFit.value) ? (
        <ExpertiseList expertiseItems={responsibilitiesFit.value} showSources={showSources} />
      ) : (
        <p className="text-gray-600">No job responsibilities fit data available.</p>
      )}
    </div>
  );
};

JobResponsibilitiesFit.propTypes = {
  responsibilitiesFit: PropTypes.object,
  showSources: PropTypes.bool
};

export default JobResponsibilitiesFit;
